import {
  ADD_TO_CART,
  DELETE_CART,
  EMPTY_CART,
  INCREASE_ITEM_QUANTITY,
  DECREASE_ITEM_QUANTITY,
  CLEAR_CART,
  GET_CHECKOUT_QUESTIONS,
} from "../types";
import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const addToCartAction =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    await dispatch({ type: ADD_TO_CART, payload: data });
    onSuccess();
  };

export const updateSimulatedPriceAction = (payload) => async (dispatch) => {
  // Update the simulated price
  await dispatch({ type: "UPDATE_SIMULATED", payload });
};

export const deleteCartAction = (payload) => async (dispatch) => {
  //Delete specific item from cart
  await dispatch({ type: DELETE_CART, payload });
};
export const emptyCartAction = () => async (dispatch) => {
  //Empty the whole cart
  await dispatch({ type: EMPTY_CART });
};
export const emptyOrderAction = () => async (dispatch) => {
  //Empty the whole cart
  await dispatch({ type: "EMPTY_ORDER" });
};
export const increaseQuantity = (payload) => async (dispatch) => {
  await dispatch({ type: INCREASE_ITEM_QUANTITY, payload: payload });
};

export const decreaseQuantity = (payload) => async (dispatch) => {
  await dispatch({ type: DECREASE_ITEM_QUANTITY, payload: payload });
};

export const addCartDetails = (payload) => async (dispatch) => {
  await dispatch({ type: "CART_DETAILS", payload: payload });
};

export const clearCartAction = () => async (dispatch) => {
  await dispatch({ type: CLEAR_CART });
};

export const clearCartDetails = () => async (dispatch) => {
  await dispatch({ type: "CLEAR_CART_DETAILS" });
};

export const updateTip = (payload) => async (dispatch) => {
  await dispatch({ type: "TIP_DETAILS", payload: payload });
};

export const updateDelivery = (payload) => async (dispatch) => {
  await dispatch({ type: "DELIVERY_UPDATE", payload: payload });
};

export const updateTableData =
  (restaurantID, customerID, tableNo, timer, name) => async () => {
    try {
      if (!timer) return; // Only timer is mandatory for all flows

      const db = firebase.firestore();
      const restaurantRef = db.collection("table").doc(restaurantID);
      const tablesRef = restaurantRef.collection("tables");
      const tableNumber = Number(tableNo);

      const querySnapshot = await tablesRef
        .where("tableNo", "==", tableNumber)
        .get();

      if (querySnapshot.empty) return;

      const tableDoc = querySnapshot.docs[0];
      if (!tableDoc.exists) return;

      // Parse the timer string
      const [value, unit] = timer.split(" ");
      const duration = Number(value);
      let expirationTimestamp = firebase.firestore.Timestamp.now();

      if (unit === "Min") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 1000
        );
      } else if (unit === "Hour") {
        expirationTimestamp = firebase.firestore.Timestamp.fromMillis(
          expirationTimestamp.toMillis() + duration * 60 * 60 * 1000
        );
      }

      const occupiedAt = firebase.firestore.FieldValue.serverTimestamp();

      // Always update the table doc, even if customerID is null
      await tableDoc.ref.update({
        customerId: customerID ?? null,
        occupiedAt,
        expireAt: expirationTimestamp,
      });

      // Only store customer-specific table info if a valid customerID is provided
      if (customerID) {
        const userTableInfoRef = db
          .collection("users")
          .doc(customerID)
          .collection("tableInfo")
          .doc();

        await userTableInfoRef.set({
          customerId: customerID,
          occupiedAt: firebase.firestore.Timestamp.now(),
          expireAt: expirationTimestamp,
          tableNumber: tableNumber,
          restaurantName: name,
          restaurantId: restaurantID,
        });
      }
    } catch (error) {
      console.error("Error updating table data:", error);
      toast.error(error.message || "Failed to update table data.");
    }
  };

export const extendTableTime =
  (restaurantID, customerID, tableNo, currentTimer, name, extendedTime) =>
  async () => {
    try {
      if (!extendedTime) return; // nothing to extend

      const db = firebase.firestore();
      const restaurantRef = db.collection("table").doc(restaurantID);
      const tablesRef = restaurantRef.collection("tables");
      const tableNumber = Number(tableNo);

      const querySnapshot = await tablesRef
        .where("tableNo", "==", tableNumber)
        .get();

      if (querySnapshot.empty) return;

      const tableDoc = querySnapshot.docs[0];
      if (!tableDoc.exists) return;

      // Use current expireAt if present, otherwise start from now
      let baseTimestamp = firebase.firestore.Timestamp.now().toMillis();

      // Add the extended minutes
      const newExpireAt = firebase.firestore.Timestamp.fromMillis(
        baseTimestamp + extendedTime * 60 * 1000
      );

      await tableDoc.ref.update({
        expireAt: newExpireAt,
      });

      // Update the user’s tableInfo if customerID is provided
      // if (customerID) {
      //   const userTableInfoRef = db
      //     .collection("users")
      //     .doc(customerID)
      //     .collection("tableInfo");

      // const activeTableInfoSnapshot = await userTableInfoRef
      //   .where("tableNumber", "==", tableNumber)
      //   .orderBy("occupiedAt", "desc")
      //   .limit(1)
      //   .get();

      // if (!activeTableInfoSnapshot.empty) {
      //   await activeTableInfoSnapshot.docs[0].ref.update({
      //     expireAt: newExpireAt,
      //   });
      // } else {
      //   await userTableInfoRef.add({
      //     customerId: customerID,
      //     occupiedAt: firebase.firestore.Timestamp.now(),
      //     expireAt: newExpireAt,
      //     tableNumber,
      //     restaurantName: name,
      //     restaurantId: restaurantID,
      //   });
      // }
      // }
    } catch (error) {
      console.error("Error extending table time:", error);
      toast.error(error.message || "Failed to extend table time.");
    }
  };

export const getCheckoutQuestions = (restaurantID) => async (dispatch) => {
  const questionsRef = firebase
    .firestore()
    .collection("checkoutQuestions")
    .where("restaurantID", "==", restaurantID)
    .orderBy("position", "asc");

  questionsRef.onSnapshot((snap) => {
    let questions = [];

    snap.forEach((doc) => {
      questions.push({ id: doc.id, ...doc.data() });
    });

    dispatch({
      type: GET_CHECKOUT_QUESTIONS,
      payload: questions,
    });
  });
};

export const getAddOns = (addOnsArray) => (dispatch) => {
  try {
    const unsubscribes = [];
    const collectedData = {};
    let receivedCount = 0;

    addOnsArray.forEach((addOnObj) => {
      const addOnID = typeof addOnObj === "string" ? addOnObj : addOnObj?.id;
      if (!addOnID) return;

      const addOnRef = firebase.firestore().collection("addOns").doc(addOnID);

      const unsubscribe = addOnRef.onSnapshot((doc) => {
        if (!doc.exists) return;

        const addOnData = doc.data();
        if (!addOnData) return;

        collectedData[addOnID] = { id: addOnID, ...addOnData };

        if (!collectedData[addOnID]._received) {
          collectedData[addOnID]._received = true;
          receivedCount++;
        }

        if (receivedCount === addOnsArray.length) {
          const finalArray = Object.values(collectedData).map(
            ({ _received, ...rest }) => rest
          );

          dispatch({
            type: "FETCH_ADD_ONS",
            payload: finalArray,
          });
        }
      });

      unsubscribes.push(unsubscribe);
    });

    return () => unsubscribes.forEach((unsub) => unsub && unsub());
  } catch (error) {
    console.error("Error fetching addOns:", error);
    toast.error(error.message);
  }
};

export const setEndLoading = (tableId, loading) => ({
  type: "END_LOADING",
  payload: { tableId, loading },
});

export const changeOrderType = (value) => (dispatch) => {
  dispatch({ type: "CHANGE_ORDER_TYPE", payload: value });
};

export const addToOrder = (item) => ({
  type: "ADD_TO_ORDER",
  payload: item,
});

export const addOrUpdateAddon = (orderItemID, addon) => {
  return {
    type: "ADD_OR_UPDATE_ADDON",
    payload: { orderItemID, addon },
  };
};

export const increaseAddonQuantity = ({ orderItemID, addonID }) => ({
  type: "INCREASE_ADDON_QTY",
  payload: { orderItemID, addonID },
});

export const decreaseAddonQuantity = ({ orderItemID, addonID }) => ({
  type: "DECREASE_ADDON_QTY",
  payload: { orderItemID, addonID },
});

export const updateItemInstructions = (orderItemID, instructions) => ({
  type: "UPDATE_ITEM_INSTRUCTIONS",
  payload: { orderItemID, instructions },
});

export const removeFromOrder = (orderItemID) => ({
  type: "REMOVE_FROM_ORDER",
  payload: orderItemID,
});
